import React from 'react'

const PoweredByIconDark = ({ width, height }: { width?: number; height?: number }) => {
  return (
    <svg width={width || 56} height={height || 30} viewBox="0 0 56 30" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M29.853 13.8123C29.7113 13.8933 29.5358 13.9338 29.3334 13.9338C29.2659 13.9338 29.1107 13.927 28.8543 13.9001V14.6356C29.077 14.6963 29.2997 14.7165 29.5291 14.7165C29.88 14.7165 30.1701 14.6221 30.4063 14.4399C30.6425 14.2577 30.8516 13.9743 31.0271 13.5829L33.0109 9.04846L32.073 9.06196L30.8719 12.0309L29.7045 9.06196H28.7666L30.3928 12.9486L30.2241 13.3332C30.1161 13.5694 29.9879 13.7314 29.853 13.8123Z"
          fill="#A7B6BD"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M35.0824 13.0633C34.8395 12.9485 34.637 12.7866 34.4886 12.5774H34.4818V13.1375H33.6721V6.92285H34.5426V9.56795C34.8665 9.17658 35.3253 8.9809 35.9124 8.9809L35.8786 8.98765C36.4522 8.98765 36.9313 9.19008 37.3159 9.59494C37.7005 9.9998 37.8894 10.5059 37.8894 11.1132C37.8894 11.7205 37.6937 12.2265 37.3226 12.6314C36.9515 13.043 36.4792 13.2387 35.9056 13.2387C35.602 13.2387 35.3321 13.178 35.0824 13.0633ZM35.7311 9.78373C35.3937 9.78373 35.1036 9.90518 34.8607 10.1346C34.6177 10.364 34.503 10.6947 34.503 11.1333C34.503 11.5719 34.6245 11.9025 34.8674 12.1252C35.1103 12.3478 35.4005 12.4558 35.7379 12.4558H35.7514C36.109 12.4558 36.3856 12.3209 36.6286 12.0712C36.8715 11.8215 36.9862 11.4976 36.9862 11.1063C36.9862 10.7217 36.8715 10.4045 36.6286 10.1548C36.3856 9.90518 36.0887 9.78373 35.7311 9.78373Z"
          fill="#A7B6BD"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M26.7346 18.7518H26.7278C26.2218 18.7518 25.8169 18.9205 25.5065 19.2512V18.8463H24.6968V22.9354H25.5672V20.4927C25.5672 20.2161 25.6482 19.9934 25.8236 19.818C25.9991 19.6425 26.2218 19.5548 26.4984 19.5548C26.7616 19.5548 26.9775 19.6493 27.1462 19.818C27.3149 19.9934 27.3959 20.2228 27.3959 20.5062V22.9354H28.2663V20.3848C28.2663 19.8989 28.1314 19.5076 27.8614 19.2107C27.5915 18.9138 27.2069 18.7518 26.7346 18.7518Z"
          fill="#A7B6BD"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M29.6695 19.3654C30.0743 18.9538 30.5737 18.7446 31.1607 18.7446C31.7005 18.7446 32.1526 18.9201 32.5035 19.2777C32.8611 19.6353 33.0433 20.0807 33.0433 20.6205C33.0433 20.6205 33.0366 20.9646 32.9623 21.1671H29.9259C29.9799 21.5044 30.1283 21.7743 30.3712 21.9633C30.6141 22.1522 30.911 22.2467 31.2687 22.2467C31.6938 22.2467 32.0919 22.0915 32.4563 21.7676L32.8679 22.3614C32.4023 22.8 31.8625 23.0159 31.2417 23.0159C30.6141 23.0159 30.0878 22.8067 29.6762 22.4019C29.2646 21.997 29.0554 21.4909 29.0554 20.8836C29.0554 20.2831 29.2646 19.777 29.6695 19.3654ZM30.3704 19.7638C30.1545 19.9459 30.0128 20.1889 29.9453 20.4925H32.1585C32.1518 20.1889 32.0506 19.9459 31.8549 19.7638C31.6524 19.5816 31.4095 19.4871 31.1194 19.4871C30.8292 19.4938 30.5863 19.5816 30.3704 19.7638Z"
          fill="#A7B6BD"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M42.4976 12.5909C42.032 13.0295 41.4922 13.2454 40.8714 13.2454C40.2439 13.2454 39.7176 13.043 39.306 12.6314C38.8944 12.2265 38.6852 11.7204 38.6852 11.1131C38.6852 10.5126 38.8944 10.0065 39.2992 9.59491C39.7041 9.1833 40.2034 8.97412 40.7905 8.97412C41.3303 8.97412 41.7756 9.14956 42.1333 9.50719C42.4909 9.86482 42.6731 10.3102 42.6731 10.85C42.6731 10.85 42.6731 11.1806 42.5921 11.3965H39.5556C39.6096 11.7339 39.7581 12.0038 40.001 12.1928C40.2439 12.3817 40.5408 12.4762 40.8984 12.4762C41.3235 12.4762 41.7216 12.321 42.086 11.9971L42.4976 12.5909ZM40.7433 9.72328C40.4531 9.73003 40.2102 9.81775 39.9943 9.99994C39.7783 10.1821 39.6366 10.4183 39.5692 10.7287H41.7824C41.7757 10.425 41.6744 10.1821 41.4788 9.99994C41.2763 9.81775 41.0334 9.72328 40.7433 9.72328Z"
          fill="#A7B6BD"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M35.9521 22.2199C35.6889 22.2199 35.4865 22.1727 35.3583 22.0647C35.2233 21.9567 35.1626 21.7745 35.1626 21.5181V19.6018H36.3705V18.846H35.1626V17.7799H34.2854V18.846H33.6241V19.6018H34.2854V21.5924C34.2854 22.0647 34.4204 22.4223 34.6835 22.6517C34.9467 22.8812 35.3111 23.0026 35.7834 23.0026C35.9926 23.0026 36.2288 22.9689 36.5054 22.9082V22.1727C36.2625 22.1996 36.0938 22.2199 35.9656 22.2199H35.9521Z"
          fill="#A7B6BD"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M41.8296 21.4712L40.5746 18.7518H40.2777L39.0428 21.5049L37.97 18.8463H37.0455L38.8539 23.0029H39.1508L40.4261 20.2971L41.7014 23.0029H42.0051L43.8067 18.8463H42.8823L41.8296 21.4712Z"
          fill="#A7B6BD"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M44.6758 19.3659C45.0875 18.961 45.5935 18.7518 46.2008 18.7518C46.7946 18.7586 47.3007 18.9543 47.7123 19.3591C48.1374 19.7707 48.3533 20.2768 48.3533 20.8706C48.3533 21.4712 48.1509 21.9772 47.7258 22.3888C47.3007 22.8004 46.7946 23.0096 46.2008 23.0096C45.5935 23.0029 45.0875 22.7937 44.6758 22.3888C44.2642 21.9772 44.0551 21.4779 44.0551 20.8774C44.0551 20.2768 44.2642 19.7707 44.6758 19.3659ZM46.1872 22.1862C46.5448 22.1862 46.8417 22.0648 47.0846 21.8151C47.3208 21.5655 47.449 21.2483 47.449 20.8704C47.449 20.4926 47.3343 20.1754 47.0914 19.9258C46.8485 19.6829 46.5516 19.5546 46.1939 19.5479H46.1872C45.8228 19.5614 45.5259 19.6829 45.283 19.9325C45.0401 20.1822 44.9254 20.4926 44.9254 20.8772C44.9254 21.2483 45.0401 21.5655 45.283 21.8151C45.5259 22.0648 45.8228 22.1862 46.1872 22.1862Z"
          fill="#A7B6BD"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M49.9669 19.3723V18.8393H49.1572V22.9284H50.0277V20.7421C50.0277 20.3845 50.1424 20.1146 50.3651 19.9122C50.5877 19.7165 50.8711 19.6153 51.2085 19.6153H51.4717V18.846C51.3772 18.819 51.2693 18.8055 51.1478 18.8055C50.6552 18.8055 50.2571 18.9945 49.9669 19.3723Z"
          fill="#A7B6BD"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M44.3461 10.9783C44.3461 10.6207 44.4608 10.3508 44.6835 10.1484C44.9061 9.95269 45.1895 9.85147 45.5269 9.85147H45.7901V9.08223C45.6956 9.05524 45.5876 9.04175 45.4662 9.04175C44.9669 9.04175 44.5687 9.23743 44.2786 9.6153V9.08223H43.4689V13.1646H44.3393V10.9783H44.3461Z"
          fill="#A7B6BD"
        />
        <rect x="52.2802" y="16.6938" width="0.870453" height="6.23487" fill="#A7B6BD" />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M54.2048 20.6342L55.8445 18.8461H54.7717L53.1792 20.6275L54.9538 22.9284H55.9997L54.2048 20.6342Z"
          fill="#A7B6BD"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M28.2591 9.07556H27.1795L25.5938 10.8637L27.3684 13.1647H28.4143L26.6194 10.8704L28.2591 9.07556Z"
          fill="#A7B6BD"
        />
        <rect x="24.6967" y="6.92944" width="0.870453" height="6.23487" fill="#A7B6BD" />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M8.9342 14.9187L20.0746 21.3088C20.466 21.5314 20.9518 21.248 20.9518 20.8027V9.02796C20.9518 8.57586 20.466 8.29921 20.0746 8.52188L8.9342 14.9187Z"
          fill="#A7B6BD"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M19.4323 5.77564L12.0233 0.121069C11.6792 -0.142091 11.1866 0.0468443 11.0989 0.465201L8.39307 13.0497L19.3648 6.7473C19.7292 6.53813 19.7629 6.03205 19.4323 5.77564Z"
          fill="#A7B6BD"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M12.0251 29.7165L19.4408 24.062C19.7715 23.8056 19.7377 23.2995 19.3801 23.0903L8.40161 16.788L11.1074 29.3724C11.1884 29.7908 11.6877 29.973 12.0251 29.7165Z"
          fill="#A7B6BD"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M6.07967 14.9196L8.99468 1.35672C9.10939 0.823649 8.5021 0.43903 8.07024 0.769668L0.607292 6.46472C0.222674 6.75487 0 7.21372 0 7.6928V22.1396C0 22.6187 0.222674 23.0775 0.607292 23.3677L8.07024 29.0628C8.5021 29.3934 9.10939 29.0088 8.99468 28.4757L6.07967 14.9196Z"
          fill="#A7B6BD"
        />
      </g>
    </svg>
  )
}

export default PoweredByIconDark
